import { render, staticRenderFns } from "./editable-field.vue?vue&type=template&id=bb925ae6&"
import script from "./editable-field.vue?vue&type=script&lang=js&"
export * from "./editable-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports